import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const AdminActivityLog = () => {
  const [activities] = useState([
    {
      id: 1,
      action: 'System Configuration Updated',
      admin: 'Main Administrator',
      timestamp: '2 minutes ago',
      type: 'config',
      icon: 'Settings',
      color: 'blue'
    },
    {
      id: 2,
      action: 'User Permissions Modified',
      admin: 'Main Administrator',
      timestamp: '15 minutes ago',
      type: 'user',
      icon: 'UserCog',
      color: 'purple'
    },
    {
      id: 3,
      action: 'Security Scan Completed',
      admin: 'System',
      timestamp: '1 hour ago',
      type: 'security',
      icon: 'ShieldCheck',
      color: 'green'
    },
    {
      id: 4,
      action: 'Financial Report Generated',
      admin: 'Main Administrator',
      timestamp: '2 hours ago',
      type: 'finance',
      icon: 'FileText',
      color: 'amber'
    },
    {
      id: 5,
      action: 'Payout Batch Processed',
      admin: 'System',
      timestamp: '3 hours ago',
      type: 'payout',
      icon: 'Banknote',
      color: 'green'
    }
  ]);

  const iconColorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    green: 'bg-green-100 text-green-600',
    amber: 'bg-amber-100 text-amber-600'
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <Icon name="FileText" className="w-5 h-5 text-primary" />
            Administrative Activity Log
          </h2>
          <p className="text-gray-600 text-sm mt-1">Recent administrative actions and system events</p>
        </div>
        <button className="text-primary hover:text-primary/80 font-medium text-sm flex items-center gap-1">
          View Full Audit Trail
          <Icon name="ExternalLink" className="w-4 h-4" />
        </button>
      </div>
      <div className="space-y-3">
        {activities?.map((activity) => (
          <div
            key={activity?.id}
            className="flex items-center gap-4 p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200"
          >
            <div className={`w-10 h-10 ${iconColorClasses?.[activity?.color]} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon name={activity?.icon} className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium text-gray-900">{activity?.action}</div>
              <div className="text-sm text-gray-600 mt-0.5">
                by {activity?.admin} • {activity?.timestamp}
              </div>
            </div>
            <Icon name="ChevronRight" className="w-5 h-5 text-gray-400 flex-shrink-0" />
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200 flex items-center justify-between text-sm">
        <div className="flex items-center gap-2 text-gray-600">
          <Icon name="Lock" className="w-4 h-4" />
          <span>All actions are logged and monitored for compliance</span>
        </div>
        <button className="text-primary hover:text-primary/80 font-medium">
          Export Logs
        </button>
      </div>
    </div>
  );
};

export default AdminActivityLog;